export const fonts = {
  heading: `'Lexend Variable', sans-serif`,
  body: `'Lexend Variable', sans-serif`,
}
